import { render, staticRenderFns } from "./InsightsLiquidatedDamagesView.vue?vue&type=template&id=0b0e502b"
import script from "./InsightsLiquidatedDamagesView.vue?vue&type=script&lang=js"
export * from "./InsightsLiquidatedDamagesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports